import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M21 12V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h7.5",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M16 2v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 2v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 10h18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6v0Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m22 22-1.5-1.5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CalendarSearch";
const CalendarSearch = memo(themed(Icon));
export {
  CalendarSearch
};
//# sourceMappingURL=calendar-search.js.map
